import React, { FC, ReactNode } from "react";
import clsx from "clsx";
import { Col, Row, Typography } from "antd";

type Props = {
  className?: string;
  label?: string;
  value: string | ReactNode;
};

export const DisplayOnlyField: FC<Props> = ({ className, label, value }) => {
  return (
    <Row className={clsx(className && className)}>
      <Col>
        {label && (
          <Row>
            <label>{label}</label>
          </Row>
        )}
        <Row>
          {" "}
          <Typography.Text>{value}</Typography.Text>
        </Row>
      </Col>
    </Row>
  );
};
